var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    {
      staticClass: "confirm-modal",
      attrs: { id: _vm.id, options: _vm.options }
    },
    [
      _vm.title
        ? _c(
            "h2",
            { staticClass: "font-semibold text-gray-800 leading-relaxed mb-3" },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          )
        : _vm._e(),
      _vm.markdown
        ? _c("MarkdownContent", {
            staticClass: "markdown-content--typography",
            attrs: { content: _vm.message }
          })
        : _c("p", { staticClass: "text-center text-gray-700 mb-4" }, [
            _vm._v(" " + _vm._s(_vm.message) + " ")
          ]),
      _c(
        "div",
        { staticClass: "flex flex-row self-end" },
        [
          _c(
            "BaseButton",
            {
              staticClass:
                "text-primary-700 border border-primary-500 mr-2 hover:bg-black-overlay",
              on: {
                click: function($event) {
                  return _vm.$ui.resolveModal(_vm.id, false)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.cancelLabel) + " ")]
          ),
          _c(
            "BaseButton",
            {
              staticClass: "text-white bg-red-500 hover:bg-red-700",
              on: {
                click: function($event) {
                  return _vm.$ui.resolveModal(_vm.id, true)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.acceptLabel) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }